/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { Suspense, useEffect } from "react";
import { SplashScreen } from "./features/SplashScreen";
import AlertProvider from "./component/alert-context/alertContextProvider";
import { AuthInit } from "./auth";
import { Outlet } from "react-router-dom";
import ChefProvider from "./component/chef-context/chefContext";
import { SettingsProvider } from "./component/settings-context/settingsContext";
import { WorkingHoursProvider } from "../app/component/context/WorkingHoursContext";
import ChefOfflinePopup from "./component/context/popupOffline";

const App: React.FC = () => {
  return (
    <Suspense fallback={<SplashScreen />}>
      <SettingsProvider>
        <AlertProvider>
          <ChefProvider>
            <WorkingHoursProvider>
              <ChefOfflinePopup></ChefOfflinePopup>
              <AuthInit>
                <Outlet />
              </AuthInit>
            </WorkingHoursProvider>
          </ChefProvider>
        </AlertProvider>
      </SettingsProvider>
    </Suspense>
  );
};

export default App;
